import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from "react";
import { WiseConfig } from "../../../Shared/features/WiseConfig";
const labelPrefix = [
    'Bij jeugd abonnement',
    'Bij jongeren abonnement',
    'Bij instap abonnement',
    'Bij compleet abonnement'
];
const HarcodedSubscriptionBlockRow = (props)=>{
    return /*#__PURE__*/ _jsxs("div", {
        className: "ms__row ms__row--content",
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "ms__cell ms__cell--subtitle",
                children: /*#__PURE__*/ _jsx("h3", {
                    className: "ms__subtitle",
                    children: props.title
                })
            }),
            props.values.map((v, i)=>{
                return /*#__PURE__*/ _jsxs("div", {
                    className: "ms__cell ms__cell--content",
                    children: [
                        /*#__PURE__*/ _jsx("p", {
                            className: "sr-text",
                            children: `${labelPrefix[i]}: ${v.srLabel}`
                        }),
                        /*#__PURE__*/ _jsx("p", {
                            className: "ms__value",
                            "aria-hidden": "true",
                            children: v.label == 'true' ? /*#__PURE__*/ _jsx("svg", {
                                className: "ms__icon",
                                width: "32",
                                height: "32",
                                children: /*#__PURE__*/ _jsx("use", {
                                    xlinkHref: "#icon--ms-check"
                                })
                            }) : v.label
                        })
                    ]
                }, `ms-${props.row}-${i}`);
            })
        ]
    });
};
export const HarcodedSubscriptionBlock = ()=>{
    const { BaseUrl, LibraryId } = WiseConfig();
    return /*#__PURE__*/ _jsx("section", {
        className: "block block--memberships",
        children: /*#__PURE__*/ _jsx("div", {
            className: "block__inner",
            children: /*#__PURE__*/ _jsxs("div", {
                className: "memberships ms",
                children: [
                    /*#__PURE__*/ _jsxs("header", {
                        className: "ms__row ms__row--header",
                        children: [
                            /*#__PURE__*/ _jsx("h2", {
                                className: "sr-text",
                                children: "Kies het abonnement dat bij jou past"
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: "ms__cell ms__cell--title",
                                children: /*#__PURE__*/ _jsx("span", {
                                    className: "sr-text",
                                    children: "Type abonnementen"
                                })
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: "ms__cell ms__cell--header",
                                children: [
                                    /*#__PURE__*/ _jsx("p", {
                                        className: "ms__title",
                                        children: "Jeugd"
                                    }),
                                    /*#__PURE__*/ _jsxs("p", {
                                        className: "ms__intro",
                                        children: [
                                            /*#__PURE__*/ _jsx("span", {
                                                className: "sr-text",
                                                children: "Dit abonnement is: gratis voor 0 tot en met 17 jarigen"
                                            }),
                                            /*#__PURE__*/ _jsx("span", {
                                                "aria-hidden": "true",
                                                children: "t/m 17 jaar Gratis"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: "ms__cell ms__cell--header",
                                children: [
                                    /*#__PURE__*/ _jsx("p", {
                                        className: "ms__title",
                                        children: "Jongeren"
                                    }),
                                    /*#__PURE__*/ _jsxs("p", {
                                        className: "ms__intro",
                                        children: [
                                            /*#__PURE__*/ _jsx("span", {
                                                className: "sr-text",
                                                children: "Dit abonnement is: gratis voor 18 tot en met 26 jarigen"
                                            }),
                                            /*#__PURE__*/ _jsx("span", {
                                                "aria-hidden": "true",
                                                children: "18 t/m 26 jaar Gratis"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: "ms__cell ms__cell--header",
                                children: [
                                    /*#__PURE__*/ _jsx("p", {
                                        className: "ms__title",
                                        children: "Instap"
                                    }),
                                    /*#__PURE__*/ _jsxs("p", {
                                        className: "ms__intro",
                                        children: [
                                            /*#__PURE__*/ _jsx("span", {
                                                className: "sr-text",
                                                children: "Dit abonnement is: gratis voor 27 jarigen en ouder"
                                            }),
                                            /*#__PURE__*/ _jsx("span", {
                                                "aria-hidden": "true",
                                                children: "27+ jaar Gratis"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: "ms__cell ms__cell--header",
                                children: [
                                    /*#__PURE__*/ _jsx("p", {
                                        className: "ms__title",
                                        children: "Compleet"
                                    }),
                                    /*#__PURE__*/ _jsxs("p", {
                                        className: "ms__intro",
                                        children: [
                                            /*#__PURE__*/ _jsx("span", {
                                                className: "sr-text",
                                                children: "Dit abonnement is: € 5 per maand voor 18 jarigen en ouder"
                                            }),
                                            /*#__PURE__*/ _jsx("span", {
                                                "aria-hidden": "true",
                                                children: "18+ jaar € 5 per maand"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    HarcodedSubscriptionBlockRow({
                        row: '1',
                        title: 'Boetevrij lenen',
                        values: [
                            {
                                label: '15 boeken per keer',
                                srLabel: 'Inbegrepen'
                            },
                            {
                                label: '6 boeken per jaar',
                                srLabel: 'Inbegrepen'
                            },
                            {
                                label: "€ 3,50 per boek",
                                srLabel: 'Niet inbegrepen, kosten € 3,50 per boek'
                            },
                            {
                                label: '15 boeken per keer',
                                srLabel: 'Inbegrepen'
                            }
                        ]
                    }),
                    HarcodedSubscriptionBlockRow({
                        row: '2',
                        title: '10 e-books en luisterboeken per 3 weken',
                        values: [
                            {
                                label: 'true',
                                srLabel: 'Inbegrepen'
                            },
                            {
                                label: "Stopt na 2 maanden",
                                srLabel: 'Niet inbegrepen, proefperiode stopt na 2 maanden'
                            },
                            {
                                label: "Stopt na 2 maanden",
                                srLabel: 'Niet inbegrepen, proefperiode stopt na 2 maanden'
                            },
                            {
                                label: 'true',
                                srLabel: 'Inbegrepen'
                            }
                        ]
                    }),
                    HarcodedSubscriptionBlockRow({
                        row: '3',
                        title: '5 online tijdschriften per 3 weken',
                        values: [
                            {
                                label: 'true',
                                srLabel: 'Inbegrepen'
                            },
                            {
                                label: "Stopt na 2 maanden",
                                srLabel: 'Niet inbegrepen, proefperiode stopt na 2 maanden'
                            },
                            {
                                label: "Stopt na 2 maanden",
                                srLabel: 'Niet inbegrepen, proefperiode stopt na 2 maanden'
                            },
                            {
                                label: 'true',
                                srLabel: 'Inbegrepen'
                            }
                        ]
                    }),
                    HarcodedSubscriptionBlockRow({
                        row: '4',
                        title: '150 online cursussen en bronnen',
                        values: [
                            {
                                label: 'true',
                                srLabel: 'Inbegrepen'
                            },
                            {
                                label: 'true',
                                srLabel: 'Inbegrepen'
                            },
                            {
                                label: 'true',
                                srLabel: 'Inbegrepen'
                            },
                            {
                                label: 'true',
                                srLabel: 'Inbegrepen'
                            }
                        ]
                    }),
                    HarcodedSubscriptionBlockRow({
                        row: '5',
                        title: 'Computer, printer, werk- en studieplekken',
                        values: [
                            {
                                label: 'true',
                                srLabel: 'Inbegrepen'
                            },
                            {
                                label: 'true',
                                srLabel: 'Inbegrepen'
                            },
                            {
                                label: 'true',
                                srLabel: 'Inbegrepen'
                            },
                            {
                                label: 'true',
                                srLabel: 'Inbegrepen'
                            }
                        ]
                    }),
                    HarcodedSubscriptionBlockRow({
                        row: '6',
                        title: 'Korting op activiteiten',
                        values: [
                            {
                                label: 'true',
                                srLabel: 'Inbegrepen'
                            },
                            {
                                label: 'true',
                                srLabel: 'Inbegrepen'
                            },
                            {
                                label: 'true',
                                srLabel: 'Inbegrepen'
                            },
                            {
                                label: 'true',
                                srLabel: 'Inbegrepen'
                            }
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("footer", {
                        className: "ms__row ms__row--footer ms__row--desktop",
                        children: [
                            /*#__PURE__*/ _jsx("div", {
                                className: "ms__cell ms__cell--title",
                                children: /*#__PURE__*/ _jsx("span", {
                                    className: "sr-text",
                                    children: "Lid worden?"
                                })
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: "ms__cell ms__cell--footer",
                                children: /*#__PURE__*/ _jsx("a", {
                                    href: `${BaseUrl}/wise-apps/opac/${LibraryId}/subscription/regular`,
                                    className: "button",
                                    children: "Kies Jeugd"
                                })
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: "ms__cell ms__cell--footer",
                                children: /*#__PURE__*/ _jsx("a", {
                                    href: `${BaseUrl}/wise-apps/opac/${LibraryId}/subscription/regular`,
                                    className: "button",
                                    children: "Kies Jongeren"
                                })
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: "ms__cell ms__cell--footer",
                                children: /*#__PURE__*/ _jsx("a", {
                                    href: `${BaseUrl}/wise-apps/opac/${LibraryId}/subscription/regular`,
                                    className: "button",
                                    children: "Kies Instap"
                                })
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: "ms__cell ms__cell--footer",
                                children: /*#__PURE__*/ _jsx("a", {
                                    href: `${BaseUrl}/wise-apps/opac/${LibraryId}/subscription/regular`,
                                    className: "button",
                                    children: "Kies Compleet"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("footer", {
                        className: "ms__row ms__row--footer ms__row--mobile",
                        children: [
                            /*#__PURE__*/ _jsx("div", {
                                className: "ms__cell ms__cell--title",
                                children: /*#__PURE__*/ _jsx("span", {
                                    className: "sr-text",
                                    children: "Lid worden?"
                                })
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: "ms__cell ms__cell--footer",
                                children: /*#__PURE__*/ _jsx("a", {
                                    href: `${BaseUrl}/wise-apps/opac/${LibraryId}/subscription/regular`,
                                    className: "button",
                                    children: "Ga naar inschrijfformulier"
                                })
                            })
                        ]
                    })
                ]
            })
        })
    });
};
